export const referralConstants = {
    REFERRAL_BALANCE_LOADING_SPINNER: 'REFERRAL_BALANCE_LOADING_SPINNER',
    REFERRAL_BALANCE_FETCH: 'REFERRAL_BALANCE_FETCH',
    REFERRAL_TRANSACTIONS_LOADING_SPINNER: 'REFERRAL_TRANSACTIONS_LOADING_SPINNER',
    REFERRAL_TRANSACTIONS_FETCH: 'REFERRAL_TRANSACTIONS_FETCH'
};